import { Step, StepLabel, Stepper, Typography } from '@mui/material';
import { InsuranceStepIcon } from './InsuranceStepIcon';
import { useSelector } from 'react-redux';
import { insuranceSelector } from '../../model';

export const InsuranceStepper = () => {
  const stepperConfig = useSelector(insuranceSelector.stepperConfig);

  return (
    <Stepper activeStep={stepperConfig.findIndex(sc => sc.active)}>
      {stepperConfig.map(step => {
        return (
          <Step key={step.label} completed={step.completed}>
            <StepLabel
              slots={{
                stepIcon: props => (
                  <InsuranceStepIcon {...props} icon={step.icon} active={step.active} completed={step.completed} />
                ),
              }}
            >
              <Typography sx={{ fontWeight: 'inherit' }}>{step.label}</Typography>
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};
